import { useEffect, useRef, useState } from 'react';

export const useNewGroup = (allGroupIds: string[]) => {

    const [newGroup, setNewGroup] = useState<string | null>(null);
    const previousGroupIds = useRef(allGroupIds);

    useEffect(() => {
        if (previousGroupIds.current.length !== allGroupIds.length) {
            setNewGroup(allGroupIds.find(id => !previousGroupIds.current.includes(id))!);
            previousGroupIds.current = allGroupIds;
        } else {
            setNewGroup(null);
        }
    }, [allGroupIds]);

    return newGroup;
};